var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotArm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "project_menagement",
    xmlns: "http://www.w3.org/2000/svg",
    width: 594.2403,
    height: 379.9185,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 594.2403 379.9185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#9c85c2;}.cls-3{fill:#a49bc7;}.cls-4{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_37);}.cls-5{fill:#5b5b82;}.cls-6{fill:#dee5f1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_37",
    x1: 12.2921,
    y1: 727.6013,
    x2: 13.2503,
    y2: 672.7071,
    gradientTransform: "translate(-352.7293 -171.162) rotate(-56.0477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aabcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f1f7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.1801,202.0132s6.8535,.8665,15.0566,6.3902c0,0,3.233-5.5785,2.8271-7.6581-.4059-2.0796-12.3187-6.9965-12.3187-6.9965l-8.3931,4.2643,2.8281,4.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.0452,218.8204s-7.1318-2.23-7.7043-5.163,7.0815-6.3147,7.0815-6.3147l.6228,11.4777Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M254.0698,191.8275l4.0151,32.602c-32.8044,6.4105-57.9169-4.7969-57.9727-11.3206,.0012-.2523,.0328-.4963,.1032-.7261,5.266-17.2021,52.2758-20.4488,53.8128-20.5471l.0416-.0082Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.0685,191.8228c-8.0189,.7967-2.3029,31.5023,4.0189,32.6113,6.3218,1.1089,3.2853-33.337-4.0189-32.6113Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256.2339,215.9458s-6.6472-11.1653-.6677-20.0453c0,0,5.8274-3.3949,13.8141-3.9192,0,0,2.1804,4.1833,3.1089,8.9401,.9285,4.7569-1.8785,14.7107-1.8785,14.7107,0,0-8.317,1.4823-14.3768,.3137Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256.1369,211.4734c-.8826,3.705,9.932,7.5143,22.3145,1.9228,0,0,3.4823-4.3838,.0186-8.4869,0,0-20.0067-3.2018-22.3331,6.5641Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271.9102,198.5214s10.4965-.641,17.39,.3414c0,0,4.6156-5.6275,.7252-10.0178,0,0-12.199-.8168-20.6451,3.1363l2.5299,6.5401Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.0282,191.8357c-42.743,4.9884-51.721,19.231-53.916,21.2732,.0012-.2523,.0328-.4963,.1032-.7261,5.266-17.2021,52.2758-20.4488,53.8128-20.5471Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.3803,191.9813s14.3831-3.1938,19.7996-1.7861c0,0,2.9906,3.1774,.1203,8.6676,0,0,6.0607-4.6823,.7252-10.0178,0,0-10.1946-1.8187-20.6451,3.1363Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.7255,204.8062s1.5809,4.6697,.7259,8.59c0,0,3.4229-4.376,.9923-8.543l-1.7182-.047Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotArm);
export default __webpack_public_path__ + "static/media/robot-arm.ac9d98264353decec12174b5d1e5da66.svg";
export { ForwardRef as ReactComponent };